import { Capacitor } from "@capacitor/core";
import { spErrorTags, spLogTags } from "@eventr/common";
import { routes } from "routing";
import { NotificationEjson } from "../../data/Rocket";
import { bs } from "../../state/bound.store";
import { useRocketchatUiStore } from "../../state/rocketchatState/rocketchatUi.store";
import { cleanRCName } from "../../utils";
import { PushNotifications } from "./plugin";

export const addPushListener = () => {
  if (Capacitor.isNativePlatform()) {
    PushNotifications.addListener("pushNotificationActionPerformed", (data: any) => {
      const ejsonString = data?.notification?.data?.ejson || data?.ejson;
      const notification: NotificationEjson = JSON.parse(ejsonString);
      // Held in a local so it stays narrowed to a string inside the timeout callback.
      const roomId = notification?.rid;
      if (roomId) {
        useRocketchatUiStore.getState().setChatFallBackName(cleanRCName(notification?.name ?? ""));
        setTimeout(async () => {
          // Dynamic import: pendingDeeplink reaches bound.store, which imports
          // clearNotifications from this file.
          const { navigateToDeeplink } = await import("feat/deeplink/pendingDeeplink");
          // Selects the chat tab and replaces any presented sheet, both derived from the
          // room route's registry entry.
          navigateToDeeplink(routes.chat.room.build({ roomType: notification?.type ?? "", roomId }));
        }, 100);
      }
    });
    PushNotifications.addListener("pushNotificationReceived", (notification) => {
      spLogTags("Notification received", ["notifications"]);
      spLogTags(JSON.stringify(notification), ["notification_payload"]);
    });
  }
};

export const loadPushToken = async () => {
  if (!Capacitor.isNativePlatform()) {
    bs().setPushToken("dummyToken");
    return;
  }

  const registerNotifications = async () => {
    let permStatus = await PushNotifications.checkPermissions();
    spLogTags(`Push permission: ${permStatus.receive}`, ["notifications"]);

    if (permStatus.receive === "prompt") {
      permStatus = await PushNotifications.requestPermissions();
    }

    if (permStatus.receive !== "granted") {
      /// Why would we throw an error? the user not wanting notifications is not an error. we should probally handle it...
      // throw new Error('User denied permissions!')

      spLogTags("User denied permissions.", ["notifications"]);
    }
    await PushNotifications.register();
  };

  await PushNotifications.addListener("registration", (token) => {
    spLogTags(token.value, ["push_token"]);

    if (Capacitor.getPlatform() === "android") {
      PushNotifications.createChannel({
        id: "high_importance_channel",
        name: "High Importance Notifications",
        importance: 4,
      });
      PushNotifications.listChannels().then((channels) => {
        console.info("Channels: ", JSON.stringify(channels));
      });
    }
    bs().setPushToken(token.value);
    // PushNotifications.removeAllDeliveredNotifications()
  });

  // Without this a failed registration (no entitlement, no network, simulator without APNs) was
  // silent: no token, no pushes, and nothing in the logs to say why.
  await PushNotifications.addListener("registrationError", (error) => {
    spErrorTags("Push registration failed", ["notifications"], error);
  });

  registerNotifications();
};

export const clearNotifications = async () => {
  if (!Capacitor.isNativePlatform()) {
    return;
  }
  PushNotifications.removeAllDeliveredNotifications();
};
